const localeTimeCustomizerForEvents = (given_time: string) => {
  const month = new Date(given_time).getMonth() + 1;
  const date = new Date(given_time).getDate();
  const dayOfWeek = new Date(given_time).getDay() ;	// 曜日(数値)
  const dayOfWeekStr = [ "日", "月", "火", "水", "木", "金", "土" ][dayOfWeek] ;	
  const local_time = month + '/' + date + "(" + dayOfWeekStr + ")"
  return local_time
}
export default localeTimeCustomizerForEvents